import { createFileRoute } from "@tanstack/react-router";
import { CrudTable } from "@/features/admin/components/CrudTable";

export const Route = createFileRoute("/_authenticated/admin/events")({
  component: () => (
    <CrudTable
      title="Events & Workshops"
      table="events"
      orderBy={{ column: "event_date", ascending: true }}
      columns={[
        { key: "title", label: "Title" },
        {
          key: "event_date",
          label: "Date",
          render: (r) => new Date(r.event_date as string).toLocaleString(),
        },
        { key: "location", label: "Location" },
        { key: "is_published", label: "Published", render: (r) => (r.is_published ? "✅" : "❌") },
      ]}
      fields={[
        { key: "title", label: "Title", required: true },
        { key: "description", label: "Description", type: "textarea" },
        { key: "event_date", label: "Event Date", type: "date", required: true },
        { key: "location", label: "Location" },
        { key: "image_url", label: "Image URL" },
        { key: "capacity", label: "Capacity", type: "number" },
        { key: "registration_url", label: "Registration URL" },
        { key: "is_published", label: "Published", type: "switch", defaultValue: true },
      ]}
    />
  ),
});
